import { facultyData } from '../facultyData';

export const businessManagementData = {
  departmentName: "Department of Business Management",
  bannerImage: "/infrastructure/businessmanagement/class-5.JPG",

  about: {
  title: "About the Department",
  content: `The Department of Business Management at Rayalaseema University is dedicated to excellence in management education, 
  research, and professional development. The department offers comprehensive programmes that integrate theoretical 
  foundations with practical business applications in the areas of finance, marketing, human resource management, 
  operations, entrepreneurship, and business analytics.

  Our curriculum is designed to develop managerial competence, leadership qualities, ethical values, and strategic 
  thinking among students. Through case studies, industry interactions, project-based learning, and research-oriented 
  training, the department prepares graduates to meet the dynamic challenges of the corporate world, public sector 
  organizations, and entrepreneurial ventures.`,

  highlights: [
    "Experienced faculty with academic and industry exposure",
    "Industry-oriented curriculum with case studies and practical training",
    "Focus on leadership development and managerial skills",
    "Research initiatives in finance, marketing, HR, and business analytics",
    "Guest lectures, seminars, workshops, and industry interactions",
    "Entrepreneurship development and career guidance support"
  ]
},

  brochure: {
    title: "Department Brochure",
    pdfLink: "/businessmanagement/department-brochure.pdf",
    description: "Download our department brochure."
  },

  hod: {
    id: "bm000",
    name: "Dr. C. Viswanatha Reddy",
    designation: "Professor and Head",
    department: "Business Management",
    email: "vsrits@gmail.com",
    mobile: "9848263463",
    photo: "/businessmanagement/prof vishwanath reddy.png",
    qualification: "M.Com., MBA, M.Phil., Ph.D.",
    specialization: "Finance, Accounting, Quantitatives, Predictive Analytics",
    profileLink: "/businessmanagement/C-VISWANATHA-REDDY.pdf",
    message: `Welcome to the Department of Business Management at Rayalaseema University. Our department strives to 
foster academic excellence, professional competence, and ethical leadership among students. We aim to bridge the 
gap between theory and practice by providing industry-relevant education and research opportunities.

We encourage our students to develop innovative thinking, managerial skills, and a strong sense of social 
responsibility. With a committed faculty and a learner-centric environment, the department continuously works 
towards shaping future business leaders who can contribute effectively to organizations and society.`
  },

  bos: {
  title: "Management",
  members: [
    {
      name: "Prof. C. Viswanadha Reddy",
      designation: "Chairperson",
      affiliation: "Dept. of MBA, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. I. Lokanadha Reddy",
      designation: "Member",
      affiliation: "Dept. of Management, University of Hyderabad"
    },
    {
      name: "Prof. N. Udaya Bhaskar",
      designation: "Member",
      affiliation: "Adikavi Nannaya University, Rajahmundry"
    },
    {
      name: "Prof. R. Sivaram Prasad",
      designation: "Member",
      affiliation: "Acharya Nagarjuna University, Guntur"
    },
    {
      name: "Prof. T. Narayana Reddy",
      designation: "Member",
      affiliation: "School of Management, JNTUA, Anantapur"
    },
    {
      name: "Prof. T. Sreenivas",
      designation: "Member",
      affiliation: "Dept. of Management, Yogi Vemana University, Kadapa"
    },
    {
      name: "Mr. Ravi Kumar",
      designation: "Member",
      affiliation: "Head, CSR, Jindal Steel Plant, AP"
    }
  ]
}
,

  faculty: facultyData.businessManagement.faculty,

  courses: {
    // undergraduate: [
    //   {
    //     name: "BBA",
    //     duration: "3 Years",
    //     eligibility: "10+2",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "MBA",
        duration: "2 Years",
        eligibility: "Graduation",
        intake: "60 seats"
      }
    ],
    research: [
      {
        name: "Ph.D. in Management",
        duration: "Minimum 3 Years",
        eligibility: "MBA/M.Com",
        areas: "Marketing, Finance, HR, Operations Management"
      }
    ]
  },

  Infrastructure: [
    "/infrastructure/businessmanagement/class-7.JPG",
    "/infrastructure/businessmanagement/class-8.JPG",
  "/infrastructure/businessmanagement/class-1.JPG",
  "/infrastructure/businessmanagement/class-2.JPG",
  "/infrastructure/businessmanagement/class-3.JPG",
  "/infrastructure/businessmanagement/class-4.JPG",
  "/infrastructure/businessmanagement/class-5.JPG",
  "/infrastructure/businessmanagement/class-6.JPG",
  

]
};